import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Index from "./pages/Index";
import SearchResults from "./pages/SearchResults";
import ListingDetail from "./pages/ListingDetail";
import HostsLanding from "./pages/HostsLanding";
import NotFound from "./pages/NotFound";
import ServiceDetail from "./pages/ServiceDetail";
import TutorDashboard from "./pages/TutorDashboard";
import CadastrarPet from "./pages/CadastrarPet";
import PagamentoResultado from "./pages/PagamentoResultado";
import AnfitriaoDashboard from "./pages/AnfitriaoDashboard";
import InboxPage from "./pages/chat/InboxPage";
import ServicoImagensLista from "@/pages/admin/ServicoImagensLista";
import ServicoImagensEditor from "@/pages/admin/ServicoImagensEditor";
import PwaInstallPrompt from "./components/PwaInstallPrompt";
import PetTagPublica from "@/pages/PetTagPublica";
import EditarPet from "@/pages/EditarPet";
import ChatSuportePage from "@/pages/ChatSuportePage";
import AnfitriaoAgenda from "@/pages/AnfitriaoAgenda";
import ChatPage from "@/pages/ChatPage";
import AnfitriaoPerfilEditar from "./pages/AnfitriaoPerfilEditar";
import AnfitriaoReservas from "@/pages/AnfitriaoReservas";
import AnfitriaoFinanceiro from "@/pages/AnfitriaoFinanceiro";
import AnfitriaoFinanceiroExtrato from "@/pages/AnfitriaoFinanceiroExtrato";
import AdminFinanceiro from "@/pages/admin/AdminFinanceiro";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/buscar" element={<SearchResults />} />
          <Route path="/listing/:id" element={<ListingDetail />} />
          <Route path="/anfitrioes" element={<HostsLanding />} />
          <Route path="/buscar-servicos" element={<SearchResults />} />
          <Route path="/servico/:id" element={<ServiceDetail />} />
          <Route path="/tutor/dashboard" element={<TutorDashboard />} />
          <Route path="/dashboard" element={<AnfitriaoDashboard />} />
          <Route path="/tutor/pets/create" element={<CadastrarPet />} />
          <Route path="/pets/novo" element={<CadastrarPet />} />
          <Route path="/pagamento/:pagamentoId/:status" element={<PagamentoResultado />} />
          <Route path="/anfitriao/dashboard" element={<AnfitriaoDashboard />} />
          <Route path="/chat" element={<ChatPage />} />
          <Route path="/chat/inbox" element={<InboxPage />} />
          <Route path="/admin/servico-imagens" element={<ServicoImagensLista />} />
          <Route path="/admin/servico-imagens/editor" element={<ServicoImagensEditor />} />
          <Route path="/admin/servico-imagens/:id/editor" element={<ServicoImagensEditor />} />
          <Route path="*" element={<NotFound />} />
          <Route path="/pet/tag/:token" element={<PetTagPublica />} />
          <Route path="/pets/:id/editar" element={<EditarPet />} />
          <Route path="/painel/chat-suporte" element={<ChatSuportePage />} />
          <Route path="/anfitriao/agenda" element={<AnfitriaoAgenda />} />
          <Route path="/anfitriao/perfil/editar" element={<AnfitriaoPerfilEditar />} />
          <Route path="/anfitriao/reservas" element={<AnfitriaoReservas />} />
          <Route path="/anfitriao/financeiro" element={<AnfitriaoFinanceiro />} />
          <Route path="/anfitriao/financeiro/extrato" element={<AnfitriaoFinanceiroExtrato />} />
          <Route path="/admin/financeiro" element={<AdminFinanceiro />} />
        </Routes>

        <PwaInstallPrompt />
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
